<template>
    <li v-click-outside="onClickOutside" class="card card-agent" :class="{ active: selectedAgent === item.Email }" v-on:click="selectAgentCard">
        <div class="card-content" role="group" aria-label="agent">
            <div class="card-header">
                <a class="card-media" v-if="item.JobSubtype !== 'CRP' && item.JobSubtype !== 'RFC'" v-bind:href="item.Url" v-bind:aria-label="'Visit ' + item.FirstName + '\'s Page'">
                        <img class="card-headshot" v-bind:alt="item.Name + ' headshot'" v-bind:src="image" onerror="this.onerror=null;this.src='/content/images/custom/agent-placeholder-avatar.webp';"/>
                </a>
                <div v-else class="card-media" role="img" v-bind:aria-label="item.Title" v-bind:style="{ 'background-image': 'url(' + image + ')' }">
                </div>

                <div class="card-agent-header-txt">
                    <span class="card-agent-title">{{ item.Title }}</span>
                    <a v-if="item.JobSubtype !== 'CRP' && item.JobSubtype !== 'RFC'" v-bind:href="item.Url"><h2 class="card-title">{{ item.Name }}</h2></a>
                    <h2 v-else class="card-title">{{ item.Name }}</h2>

                    <ul v-if="item.Tags" class="card-agent-tags">
                        <li v-for="tag in item.Tags">{{ tag.Text }}</li>
                    </ul>
                </div>
            </div>

            <div ref="agentDetails" class="card-agent-info" style="display:none;">
                <div class="card-agent-offices">
                    <div class="card-agent-office" v-for="(office, index) in item.Offices">
                        <div class="row">
                            <div class="col-md-6">
                                <div class="card-agent-office-address-wrap">
                                    <span class="card-agent-office-address-label">{{ office.label }}</span>
                                    <p class="card-agent-office-address">
                                        {{ office.Address1 }} <br/>
                                        <span v-if="office.Address2"> {{ office.Address2 }} <br/></span>
                                        {{ office.City }}, {{ office.State }} {{ office.Zipcode }}
                                    </p>

                                    <a class="card-agent-office-link" target="_blank" v-bind:href="`https://maps.google.com/?q=${office.Latitude},${office.Longitude}`">Get Directions</a>
                                </div>
                            </div>

                            <div class="col-md-6">
                                <ul class="card-agent-contact-list">
                                    <li v-if="index === 0 && item.JobSubtype !== 'CRP' && item.JobSubtype !== 'RFC'">
                                        <span class="icon-icon-chatBubble" aria-hidden="true"></span>
                                        <a class="agent-request-quote-selector" v-on:click="clickEventRequest" v-bind:href="item.RequestQuoteUrl">{{ requestText }}</a>
                                    </li>
                                    <li v-if="index === 0">
                                        <span class="icon-icon-Mail" aria-hidden="true"></span>
                                        <a class="agent-mailto-selector" v-on:click="clickEventEmail" v-bind:href="'mailto:' + item.Email">Send Email</a>
                                    </li>
                                    <li>
                                        <span class="icon-icon-Tel" aria-hidden="true"></span>
                                        <a class="agent-phone-selector" v-on:click="clickEventPhone" v-bind:href="'tel:' + office.Phone">{{ office.Phone }}</a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>

                <a v-if="item.JobSubtype !== 'CRP' && item.JobSubtype !== 'RFC'" v-bind:aria-label="'Visit ' + possessiveFirstName + ' Page'" v-bind:href="item.Url" class="card-agent-visit-link btn btn--quaternary"><span class="icon-icon-devices" aria-hidden="true"></span><span class="txt">Visit {{ possessiveFirstName }} Page</span></a>
            </div>

            <button :class="{ active: mobileToggle }" type="button" class="agent-show-details hide-desktop" v-on:click="toggleDetails">{{toggleMessage}}<span class="icon-icon-DownArrow"></span></button>
        </div>
    </li>
</template>

<script>
    import imageOptimizer from '../../common/utils/image-optimizer';
    import vClickOutside from 'v-click-outside';
    import { mapState, mapActions, mapMutations } from 'vuex';

	export default {
        props: ['item'],
        data: function () {
			return {
				mobileToggle: false,
                toggleMessage: 'Show Details'
			}
		},
        directives: {
            clickOutside: vClickOutside.directive
        },
        computed: {
            ...mapState({
                selectedAgent: state => state.listing.selectedAgent,
            }),
            image: function () {
                let html = document.querySelector('html');

                if (html.classList.contains('webp')){
                    if (this.item.Image !== null && this.item.Image !== "") {
                        return imageOptimizer.getOptimizedImageUrl(this.item.Image, 'webp');
                    }
                    else {
                        return '/content/images/custom/agent-placeholder-avatar.webp';
                    }
                }
                else {
                    if (this.item.Image !== null && this.item.Image !== "") {
                        return imageOptimizer.getSanitizeMediaUrl(this.item.Image);
                    }
                    else {
                        return '/content/images/custom/agent-placeholder-avatar.webp';
                    }
                }
            },
            requestText: function() {
                return this.item.IsWealthManagementAdvisor ? 'Request Meeting' : 'Request Quote';
            },

            possessiveFirstName: function () {
                return this.item.FirstName.endsWith('s') ? this.item.FirstName + '\'' : this.item.FirstName + '\'s';
            }
        },
        mounted: function () {
		},
        methods: {
            ...mapActions('listing', { selectAgent: 'selectAgent' }),
            clickEventRequest(event) {
                if (window.versaTagObj) {
                    versaTagObj.onready(function () {
						versaTagObj.generateRequest("http://www.fbfs.com/findanagent/requestquote"); 
                    });
                }
            },
			clickEventEmail(event) {
				if (window.versaTagObj) {
					versaTagObj.onready(function () {
						versaTagObj.generateRequest("http://www.fbfs.com/findanagent/sendemail");
					});
				}
			},
			clickEventPhone(event) {
				if (window.versaTagObj) {
					versaTagObj.onready(function () {
						versaTagObj.generateRequest("http://www.fbfs.com/findanagent/clicktocall");
					});
				}
			},
            selectAgentCard(event) {
                if(!event.target.href && !event.target.parentElement.href){
                    this.selectAgent(this.item.Email);
                }                
            },
            toggleDetails() {
                $(this.$refs["agentDetails"]).slideToggle();
                this.mobileToggle = !this.mobileToggle;

                if(this.mobileToggle){
                    this.toggleMessage = 'Hide Details';
                }else{
                    this.toggleMessage = 'Show Details';
                }
            },
            onClickOutside() {
                //if (this.item.Email === this.selectedAgent) {
                //    this.selectAgent(this.item.Email);
                //}
            }
        },
    }
</script>